export const SCORING_LABELS = {
  correctness: 'Accuracy',
  speed: 'Speed',
  approach: 'Approach',
} as const;

/** Map an attainment percentage to a performance tier for the stat-card scheme
 *  (stat-cards.css `--perf-*` tokens): high >=70%, med 40–70%, low <40%.
 *  Callers pass 'neutral' explicitly for descriptive/non-performance metrics. */
export function perfTier(pct: number): 'high' | 'med' | 'low' {
  if (pct >= 70) return 'high';
  if (pct >= 40) return 'med';
  return 'low';
}
